import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const LostCustomer = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_7115_583)">
          <path
            d="M23.8741 1.16382L11.5 4.03882V29.4138L23.8741 31.1638V1.16382Z"
            fill="#E61D27"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.8385 14.3399L15.5 10.7188C15.2204 12.0436 14.7042 15.8128 15.1418 16.6296L19.2549 18.2272C21.0052 18.6283 21.4865 15.9732 19.955 15.5721L16.8385 14.3399Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.93756 22.8125L10.5473 17.3224L13.1876 19.1875L11.5938 24.4688L8.50001 28.5C7 30.0938 5.46875 27.9062 6.31735 27.0845L8.93756 22.8125Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.93749 11.75L13.0633 9.77441C17.2932 9.77441 16.2082 14.0774 14.0479 18.1611C14.5219 19.0727 18.4601 24.3965 19.4446 26.6573C20.4291 28.9181 18.0954 29.465 17.2932 28.3347C16.491 27.2043 10.9849 19.5103 10.5109 17.9059C10.4622 17.6749 10.4886 17.0761 11.393 13.7797L10.7101 14.0774L9.79954 16.3278C9.09377 17.9059 6.75 16.9688 7.34375 15.3125L8.93749 11.75Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9941 9.0934C13.4836 8.65583 13.1189 6.57738 14.5045 5.22822C17.0206 3.51441 18.2239 6.94205 17.4582 8.03598C16.6924 9.12991 14.5045 9.53098 13.9941 9.0934Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7115_583">
            <rect width="32" height="32" fill="white" transform="translate(0.272827 0.163818)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default LostCustomer
